export default function (widget) {
    const m = widget.m;
    const ns = widget.ns;

    const widgetContainer = {

        // controller: function () {
        //   const ctrl = {};
        //   return ctrl;
        // },

        view: function (ctrl, props) {
            const extraClass = props.extraClass || '';
            const error = props.error;

            return (
                m('p', {
                        className: extraClass + ns + '__errormsg',
                        title: error.raw,
                        lang: 'en',
                    },
                    error.msg || 'Widget Error!'
                )
            );
        },
    };

    return widgetContainer;

}
